<template>
  <el-dialog
    title="提示"
    width="800px"
    :modal="false"
    @close="closeDialog"
    :visible="testTagDialogVisible"
  >
    <div class="table mb20 flex">
      <el-table stripe :data="list" :cell-style="timeStyle" height="600">
        <el-table-column prop="div" label="标签值" width="180" align="center">
        </el-table-column>
        <el-table-column
          prop="percentage"
          label="预估人数/占比"
          width="180"
          align="center"
        >
          <template v-slot="scope">
            <div class="flex arrays">
              <div class="flex flex-center">
                <span>{{ scope.row.count }}</span>
                <span>({{ scope.row.percentage }})</span>
              </div>
              <!-- <el-progress :percentage="scope.row.number"></el-progress> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="formulas"
          label="公式"
          width="380"
          align="center"
        >
          <template v-slot="scope">
            <div class="flex notes item-center">
              <div
                class="flex flex-center"
                v-for="(v, index) in scope.row.formulas"
                :key="index"
              >
                <span class="title">{{ v.name }}</span>
                <div class="flex">
                  <div class="flex perhaps item-center">
                    <span>|</span>
                    <span class="tips">且</span>
                    <span>|</span>
                  </div>
                  <div class="flex orperhaps item-center">
                    <span>|</span>
                    <span class="tipsor">或</span>
                    <span>|</span>
                  </div>
                  <div class="flex conditions">
                    <div class="flex topTitle">
                      <span>{{ v.rules[0].keyMap }}</span>
                      <span class="active">相对当前的时间</span>
                      <span>在 过去 3天内</span>
                    </div>
                    <div class="flex bottomTitle">
                      <span>姓名</span>
                      <span class="active">等于</span>
                      <span>张三</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="example-footer flex flex-center">
      <el-button size="small" @click="closeDialog">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    testTagDialogVisible: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      newList: []
      // list: [
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      //   {
      //     div: "全部",
      //     percentage: "5%",
      //     number: 10,
      //     count: 0,
      //   },
      // ],
    };
  },
  watch: {},
  created() {
    // this.get_init()
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.$emit("closeTestTagDialog");
    },
    // get_init(){
    //   console.log(785)
    //    this.list.forEach((item,index) => {
    //       item['formulas'] = this.tagRunIn[index].rules
    //     })
    //     console.log(this.list)
    // },
    timeStyle({ row, column, rowIndex, columnIndex }) {
      return "height: 80px";
    }
  }
};
</script>

<style scoped lang="scss">
.arrays {
  flex-direction: column;
}

.notes {
  flex: 1;
  padding: 40px 0;
  margin-left: 20px;
  overflow-y: scroll;
  height: 50px;
  flex-direction: column;
  .title {
    display: block;
    height: 50px;
    line-height: 50px;
  }
  .perhaps {
    width: 30px;
    flex-direction: column;
    .tips {
      display: block;
      text-align: center;
      line-height: 20px;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      background: #166dff;
      color: #ffffff;
      font-size: 12px;
      margin-top: 2px;
      margin-bottom: 2px;
    }
  }
  .orperhaps {
    width: 25px;
    margin-top: 20px;
    flex-direction: column;
    margin-left: -6px;
    .tipsor {
      display: block;
      text-align: center;
      line-height: 20px;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      background: #f7970d;
      color: #ffffff;
      font-size: 12px;
      margin-top: 2px;
      margin-bottom: 2px;
    }
  }
  .conditions {
    flex-direction: column;
    color: #222222;
    .topTitle {
      margin-left: -30px;
      span {
        font-size: 13px;
        &.active {
          color: #e9051f;
        }
      }
    }
    .bottomTitle {
      margin-top: 26px;
      span {
        font-size: 13px;
        &.active {
          color: #e9051f;
        }
      }
    }
  }
}
</style>
